import api from '@/libs/axios'
import { DemandeCapitalDeces } from '../models/dossiers/demandesCapitalDeces/demandeCapitalDeces'

const resource = 'DemandesCapitalDeces'
const baseResource = 'dossier'

export default class DemandeCapitalDecesRessources {
  public async get(dossierId: string) : Promise<any> {
    const response = await api.get(`${baseResource}/${dossierId}/${resource}`)
    return response.data
  }

  public async put(dossierId : string, demande: DemandeCapitalDeces, config: any) : Promise<DemandeCapitalDeces> {
    let formData = new FormData();

    
    if (demande.dateCpam) formData.append('dateCpam', demande.dateCpam)
    if (demande.datePrevoyance) formData.append('datePrevoyance', demande.datePrevoyance)
    if (demande.dateAutres) formData.append('dateAutres', demande.dateAutres)


    if (demande.commentaire) formData.append('commentaire', demande.commentaire)
    demande.fichiers?.forEach((file: File) => formData.append('fichiers', file));

    const response = await api.put(`${baseResource}/${dossierId}/${resource}`, formData, config)
    return response.data
  }

  public async deleteFile(dossierId: string, id: string, fileId: string) : Promise<any> {
    const response = await api.delete(`${baseResource}/${dossierId}/${resource}/${id}/Files/${fileId}`)
    return response.data
  }
}
